import React from 'react';
import { startCase } from 'lodash';

import Chip from 'shared/components/atoms/Chip/Chip';

import COLORS from 'shared/styles/colors';
import { VettingStatus } from 'shared/typings/user/enums';

interface Props {
  vettingStatus: VettingStatus;
}
const CreatorVettingStatus: React.FC<Props> = ({ vettingStatus }) => {
  let label: string;
  if (vettingStatus === VettingStatus.NEW) {
    label = 'Registered';
  } else if (vettingStatus === VettingStatus.PENDING) {
    label = 'Pending Review';
  } else label = startCase(vettingStatus.toLowerCase());
  switch (vettingStatus) {
    case VettingStatus.NEW:
      return <Chip label={label} square color={COLORS.SECONDARY500} bgColor={COLORS.SECONDARY50} />;
    case VettingStatus.APPROVED:
      return <Chip label={label} square color={COLORS.GREEN700} bgColor={COLORS.GREEN100} />;
    case VettingStatus.REJECTED:
      return <Chip label={label} square color={COLORS.RED700} bgColor={COLORS.RED50} />;
    case VettingStatus.PENDING:
      return <Chip label={label} square color={COLORS.ORANGE700} bgColor={COLORS.ORANGE100} />;
    default:
      return null;
  }
};

export default CreatorVettingStatus;
